<template>

    <div class="overflow-y-scroll flex-1">
        <div class="p-32">

            <p class="text-body font-semibold mb-12">
                {{ relatedApplications.length }} {{ $t('applications.related_applications') }}
            </p>

            <ul class="rounded-6 overflow-hidden border border-primary-20">
                <li
                    v-for="app in relatedApplications"
                    :key="'app-' + app.id"
                    class="odd:bg-primary-5 relative"
                >
                    <a class="flex items-center px-16 py-8 cursor-pointer group" @click="goToApplication(app)">
                        <div class="mr-auto">
                            <span class="font-semibold group-hover:text-primary trans-ease text-body mb-4">
                                {{ translated(app.stage.job.title, locale, true) }}
                            </span>
                            <span>
                                {{ app.createdMoment.locale(locale).format(dateFormat) }}
                            </span>
                        </div>
                        <div class="flex pl-16">
                            <div class="h-32 w-32 flex items-center justify-center rounded-6 text-primary-80 trans-ease group-hover:text-primary">
                                <svg-icon type="visibility" class="max-w-16 max-h-16"></svg-icon>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>

        </div>
    </div>
</template>

<script>
import Application from '../models/Application';
import { mapState } from 'pinia';
import {useMainStore} from '../state/store';
import SvgIcon from './ui/SvgIcon.vue';

export default {
    components: {
        'svg-icon': SvgIcon,
    },
    props: {
        application: {
            type: Application,
            required: true,
        }
    },
    computed: {
        ...mapState(useMainStore, ['locale', 'dateFormat']),
        relatedApplications () {
            return this.application.related_applications.filter(app => app.id !== this.application.id);
        }
    },
    methods: {
        goToApplication(app) {
            this.$router.push({ name: 'application', params: { id: app.id }});
        }
    }
}
</script>
